import { Button as MuiButton } from '@mui/material'
import React from 'react'

export default function Button({ variant = "contained", label, children, ...other }) {
    return (
        <MuiButton variant={variant} {...other}>{children ? children : label}</MuiButton>
    )
}
